/// <amd-module name="Agile/Common/Redux/TeamSettings/TeamSettingsSelectors" />
import { ITeamSettingsAwareState } from "Agile/Common/Redux/TeamSettings/TeamSettingsContracts";
import { IIterationData, ITeamSettings } from "Agile/Contracts/Common";
import * as Reselect from "Reselect";
import { equals } from "VSS/Core/Util/String";

export const getTeamSettings = (state: ITeamSettingsAwareState): ITeamSettings => state.teamSettingsState.teamSettings;
export const getWeekends = (state: ITeamSettingsAwareState): number[] => state.teamSettingsState.teamSettings.weekends.days;
export const getAllIterations = Reselect.createSelector(getTeamSettings, (teamSettings: ITeamSettings) => {
    const { previousIterations = [], futureIterations = [], currentIteration } = teamSettings;

    return [...previousIterations, ...(currentIteration ? [currentIteration] : []), ...futureIterations];
});
export const getIteration = (state: ITeamSettingsAwareState, iterationId: string): IIterationData | undefined => {
    const allIterations = getAllIterations(state);
    return allIterations.find(itr => equals(itr.id, iterationId, true));
};

export const isCurrentIteration = (state: ITeamSettingsAwareState, iterationId: string): boolean =>
    !!state.teamSettingsState.teamSettings.currentIteration && equals(state.teamSettingsState.teamSettings.currentIteration.id, iterationId, true);
